import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Redirect, useHistory, useLocation } from 'react-router';


interface IQrCodeCheckContext {
    isSearching: boolean
    isSearchDone: boolean
    qrCodeInfo?: IQrCodeInfo
    qrCodeSearch: string

    updateSearch: (newSearch: string) => void
    doSearch: () => void
}

interface IQrCodeInfo {
    sku: string
    country: string
    customerCode: string
    customerDescription: string
}

export let qrCodeInfoContext = React.createContext({} as IQrCodeCheckContext);

let { Provider } = qrCodeInfoContext;

let QrCodeCheckProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let history = useHistory();
    let location = useLocation();

    let [isSearching, setSearching] = useState(false);
    let [isSearchDone, setSearchDone] = useState(false);
    let [qrCodeInfo, setQrCodeInfo] = useState<IQrCodeInfo>();

    let [qrCodeSearch, setQrCodeSearch] = useState('');


    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { qrCodeSearch } }} />


    let processState = (state: any) => {
        if (state.qrCodeSearch) {
            setQrCodeSearch(state.qrCodeSearch)
        }

        searchQrCode(state.qrCodeSearch);
    }

    let doSearch = () => {
        if (qrCodeSearch === '')
            return;

        history.push(location.pathname, { qrCodeSearch });
    }

    let searchQrCode = async (qrCode: string) => {
        if (qrCode === '')
            return;

        try {
            setSearchDone(false);
            setSearching(true);

            let res = await axios.get('/api/Product/SearchQr', { params: { qrCode } });
            if (res.data)
                setQrCodeInfo(res.data);

            setSearchDone(true);

        } catch (err) { }
        finally {
            setSearching(false);
        }
    }

    let updateSearch = (newSearch: string) => {
        setQrCodeSearch(newSearch);
    }


    return (
        <Provider
            value={{
                isSearching,
                isSearchDone,
                qrCodeInfo,
                qrCodeSearch,

                updateSearch,
                doSearch
            }}
        >
            {children}
        </Provider>
    )
}

export default QrCodeCheckProvider;